import BaseService from './base.service';

class ExpenseTypeService extends BaseService {
  get basePath() {
    return 'expense/types';
  }
}

export default new ExpenseTypeService();
